import { forwardRef, useImperativeHandle, useCallback, useState } from 'react'

import { CarNode } from '@/apollo/graphql'
import { Modal } from '@/components'
import { t } from '@/i18n'

import { useData } from '../useData'
import CarForm from './form'
import { ICar } from '@/types'

interface IEditCarControl {
  edit: (bool: boolean) => void
}

const EditCar = forwardRef<IEditCarControl, { node?: Partial<CarNode> }>(
  ({ node }, ref) => {
    const { loading, submitting, onSubmit } = useData({ id: node?.id })
    const [visible, setVisible] = useState(false)

    useImperativeHandle(
      ref,
      () => ({
        edit: (bool: boolean) => setVisible(bool),
      }),
      [],
    )

    const onSubmitForm = useCallback(
      (d: ICar) => {
        delete d.activeDeal
        onSubmit(`cars/${node?.id}/`, true, () => {
          setVisible(false)
        })(d)
      },
      [node?.id, onSubmit],
    )

    if (!visible) return null

    return (
      <Modal
        visible={visible}
        title={t('cars')}
        onClose={() => setVisible(false)}
      >
        <CarForm
          loading={loading}
          initialData={node}
          onSubmit={onSubmitForm}
          isEditing={visible}
          submitting={submitting}
          onCancel={() => setVisible(false)}
        />
      </Modal>
    )
  },
)

export default EditCar
